<template>
  <div class="home-wrap-content">
    <BannersSlider />
    <div class="clear" style="height: 32px">&nbsp;</div>
    <div class="scroll_mobile_button" @click="scroll"><span></span></div>
    <!-- <div class="clear" style="height: 32px;">&nbsp;</div> -->
    <Features />
    <template v-if="sliderItemsPopular.length">
      <div class="clear" style="height: 32px">&nbsp;</div>
      <scroll ref="element">
        <ProductsSlider
          :title="$t('home.popularProducts')"
          :products="sliderItemsPopular"
          class="wow bounceInDown"
        />
      </scroll>
    </template>
    <template v-if="sliderItemsUsed.length">
      <div class="clear" style="height: 32px">&nbsp;</div>
      <scroll ref="element">
        <ProductsSlider
          :title="$t('home.usedIphone')"
          :products="sliderItemsUsed"
          class="wow bounceInDown"
        />
      </scroll>
    </template>
    <div class="clear" style="height: 32px">&nbsp;</div>
    <TwoBanners />
    <div class="clear" style="height: 32px">&nbsp;</div>
    <ProductsSlider
      :title="$t('home.accessories')"
      :products="sliderItemsAccessories"
    />
    <div class="clear" style="height: 32px">&nbsp;</div>
    <OneBanner />
    <div class="clear" style="height: 32px">&nbsp;</div>
    <!-- <ProductSliderScroll
      :title="$t('home.accessories')"
      :products="sliderItemsAccessories"
    />
    <div class="clear" style="height: 32px;">&nbsp;</div> -->
    <WhyUs />
    <Reviews />
    <div class="clear" style="height: 32px">&nbsp;</div>
    <BlogSlider :title="$t('home.news')" />
    <!--<Test/>-->
  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import WOW from 'wow.js'
import BannersSlider from '@/components/home/BannersSlider'
import ProductsSlider from '@/components/product/ProductsSlider'
import BlogSlider from '@/components/blog/BlogSlider'
import Features from '@/components/home/Features'
import TwoBanners from '@/components/home/TwoBanners'
import OneBanner from '@/components/home/OneBanner'
import WhyUs from '@/components/home/WhyUs'
import Reviews from '@/components/Reviews'
// import Test from '@/components/Test'
import Scroll from '@/components/home/Scroll'
// import ProductSliderScroll from '@/components/product/ProductSliderScroll'

export default {
  name: 'HomePage',
  components: {
    BannersSlider,
    ProductsSlider,
    BlogSlider,
    Features,
    TwoBanners,
    OneBanner,
    WhyUs,
    Reviews,
    Scroll,
    // ProductSliderScroll,
    // Test,
  },
  methods: {
    scroll() {
      this.$refs.element.scrollTo()
    },
  },
  metaInfo() {
    return {
      title:
        'iPhone, iPad, Apple Watch, Mac (б/у и оригинал) купить ️ по лучшей цене в Киеве, Виннице | AppTown',
      meta: [
        {
          name: 'description',
          content:
            'Купить товары Apple ➤➤➤ в интернет-магазине App town  Гарантия | Продажа продукции Apple по выгодной цене Ѽ Кредит на любую модель ✓ Оплата частями ️ Экспресс-доставка по Украине | (073) 143-00-22',
        },
        {
          property: 'og:locale',
          content: this.$store.state.lang ? 'ru_UA' : 'uk_UA',
        },
        {
          property: 'og:site_name',
          content: 'AppTown',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:title',
          content:
            'iPhone, iPad, Apple Watch, Mac (б/у и оригинал) купить ️ по лучшей цене в Киеве, Виннице | AppTown',
        },
        {
          property: 'og:description',
          content:
            'AppTown – сеть магазинов техники и сервисных центров | г.Винница | Огромный выбор техники Apple | iPhone, iPad, MacBook, Apple Watch, Apple TV | Доставка по всей территории Украины | Самые выгодные цены | Официальная гаратия',
        },
        {
          property: 'og:url',
          content: 'https://apptown.com.ua/',
        },
      ],
    }
  },
  computed: {
    sliderItemsUsed() {
      return this.$store.state.usedPhones
    },
    sliderItemsPopular() {
      return this.$store.state.popularProducts
    },
    sliderItemsAccessories() {
      return this.$store.state.accessories
    },
  },
  // methods: mapActions(['setHeadline']),
  // beforeMount() {
  //   this.setHeadline(this.$t('title.home'))
  // },
  beforeMount() {
    this.$store.dispatch('setHeadline', '')
    this.$store.dispatch('setBreadcrumbs', [])
  },
  mounted() {
    new WOW({
      live: false,
    }).init()
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'home',
    })
  },
}
</script>

<style>
.home-wrap-content {
  margin-top: 202px;
}
@media only screen and (max-width: 1024px) {
  .home-wrap-content {
    margin-top: 0;
  }
}
</style>
